import type { AnyAction } from "redux";

export const notify = (text: string, variant: string): AnyAction => ({
  type: "ENQUEUE_SNACK",
  payload: {
    key: crypto.getRandomValues(new Uint32Array(1))[0],
    message: text,
    options: { variant },
  },
});

export const notifySuccess = (text: string): AnyAction => notify(text, "success");
export const notifyError = (text: string): AnyAction => notify(text, "error");
